import { ReactNode, useState } from "react"
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import styled from "styled-components"

interface CollapseProps {
  children: ReactNode[];
  background?: string;
}

export const Collapse = ({ children, background = '#fff' }: CollapseProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Content background={background} isOpen={isOpen}>
      <Head onClick={() => setIsOpen(!isOpen)}>
        {children[0]}
        {!isOpen ? (
          <AiOutlinePlusSquare size={50} cursor="pointer" />
        ) : (
          <AiOutlineMinusSquare size={50} cursor="pointer" />
        )}
      </Head>
      <Body isOpen={isOpen}>{children[1]}</Body>
    </Content>
  );
};

const Content = styled.div<{ background: string; isOpen: boolean }>`
  ${({ background }) => background && `background: ${background}`};
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '114px')};
  transition: all 0.2s;
  overflow: hidden;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin-left: -14px;
    margin-right: -14px;
    max-height: ${({ isOpen }) => (isOpen ? '1000px' : '82px')};
  }
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 48px;
  font-size: 38px;
  color: ${({ theme }) => theme.colors.blue.dark};
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 24px;
    padding: 16px 24px;

    svg {
      transform: scale(0.6) translateX(20px);
    }
  }
`;

const Body = styled.div<{ isOpen: boolean }>`
  padding: 0 48px 32px;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: all 0.2s;

  * {
    font-size: 26px;
    color: ${({ theme }) => theme.colors.gray.darker};
  }

  ul {
    padding-left: 16px;

    li {
      list-style-type: square;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0 24px 16px;

    * {
      font-size: 18px;
    }

    > * {
      transform: translateY(-14px);
    }
  }
`;